import { baseApi } from "../baseApi";

const DISTRICT_BASE_URL = "/district";

export const districtApi = baseApi.injectEndpoints({
  tagTypes: ["District"],

  endpoints: (builder) => ({
    createDistrict: builder.mutation({
      query: (payload) => ({
        url: `${DISTRICT_BASE_URL}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "District", id: "LIST" },
      ],
    }),

    getDistrictList: builder.query({
      query: (params) => ({
        url: `${DISTRICT_BASE_URL}`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "District",
                _id,
              })),
              { type: "District", id: "LIST" },
            ]
          : [{ type: "District", id: "LIST" }],
    }),

    getDistrictDetail: builder.query({
      query: (id) => `${DISTRICT_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "District", id },
        { type: "District", id: "LIST" },
      ],
    }),

    getDistrictsByRegionId: builder.query({
      query: (regionId) => ({
        url: `${DISTRICT_BASE_URL}/region/${regionId}`,
        method: "GET",
      }),
      providesTags: (result, error, regionId) => [
        { type: "District", id: `Region-${regionId}` },
        { type: "District", id: "LIST" },
      ],
    }),

    getMultipleDistrictsByMultipleRegionId: builder.query({
      query: (params) => ({
        url: `${DISTRICT_BASE_URL}/region`,
        method: "GET",
        params,
      }),
      providesTags: (result, error, regionId) => [
        { type: "District", id: "LIST" },
      ],
    }),

    updateDistrict: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;

        return {
          url: `${DISTRICT_BASE_URL}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "District", _id },
        { type: "District", id: "LIST" },
      ],
    }),

    updateDistrictStatus: builder.mutation({
      query: ({ id, status }) => {
        return {
          url: `${DISTRICT_BASE_URL}/${id}/status`,
          method: "PUT",
          body: { status },
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: "District", id },
        { type: "District", id: "LIST" },
      ],
    }),

    getDdlDistrictList: builder.query({
      query: (params) => ({ url: `${DISTRICT_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "District",
                _id,
              })),
              { type: "District", id: "LIST" },
            ]
          : [{ type: "District", id: "LIST" }],
    }),
  }),
});

export const {
  useCreateDistrictMutation,
  useGetDistrictListQuery,
  useLazyGetDistrictListQuery,
  useGetDistrictDetailQuery,
  useGetDistrictsByRegionIdQuery,
  useGetMultipleDistrictsByMultipleRegionIdQuery,
  useLazyGetMultipleDistrictsByMultipleRegionIdQuery,

  useLazyGetDistrictsByRegionIdQuery,
  useUpdateDistrictMutation,
  useUpdateDistrictStatusMutation,

  useGetDdlDistrictListQuery,
  useLazyGetDdlDistrictListQuery,
} = districtApi;
